import Helper from './Helper';

class Header {
  constructor(config = {}) {
    const {
      burgerSelector,
      menuItemLevel0Selector,
      menuItem,
      header,
      searchOpenSelector,
      searchCloseSelector,
      searchContainerSelector,
      burgerClass,
      mainNavSelector,
    } = config;

    this.mainNav = document.querySelector(mainNavSelector);
    this.burgerSelector = burgerSelector;
    this.body = document.querySelector('body');
    this.header = header;
    this.menuItemLevel0Selector = menuItemLevel0Selector;
    this.menuItem = menuItem;
    this.searchOpenItems = document.querySelectorAll(searchOpenSelector);
    this.searchCloseItems = document.querySelectorAll(searchCloseSelector);
    this.searchContainer = document.querySelector(searchContainerSelector);
    this.burgerSelector = burgerSelector;
    this.burgerClass = burgerClass;
    this.openItem = "";
    this.closeItem = "";

    this.headerBottomPart = document.querySelector('.site-header__menu-bottom-part');

    if (this.header) {
      this.menuItems = document.querySelectorAll(this.menuItem);
      this.burger = document.querySelector(this.burgerSelector);
      this.bindMenuEvents()
      this.checkIfHeaderWithImage();
    }
  }

  bindMenuEvents() {

    this.menuItems.forEach((menuItem) => {
      menuItem.addEventListener('click', e => {

        if (e.target.classList.contains('.main-menu__item--has-children')) {
          e.preventDefault();
        }

        if (menuItem.classList.contains('main-menu__item--level-0') && window.matchMedia('(min-width: 1170px)').matches) {
          this.openMenu(menuItem);
        }
      })
    })

    this.searchOpenItems.forEach((searchOpen) => {
      this.openItem = searchOpen;
      searchOpen.addEventListener('click', e => {
        this.openSearch();
      });
    })

    this.searchCloseItems.forEach((searchClose) => {
      this.closeItem = searchClose;
      searchClose.addEventListener('click', e => {
        this.closeSearch();
      });
    })

    this.mainNav.addEventListener('touchstart', e => {
      this.makeHeaderWhite(true);
    });
    this.mainNav.addEventListener('touchend', e => {
      this.makeHeaderWhite(false);
    });
    this.mainNav.addEventListener('mouseenter', e => {
      this.makeHeaderWhite(true);
    });
    this.mainNav.addEventListener('mouseleave', e => {
      this.makeHeaderWhite(false);
    });

    if (this.burger) {
      this.burger.addEventListener('click', (e) => {
        this.toggleBurger();
      })
    }

    document.querySelector('.main-wrapper').addEventListener('click', (e) => {
      this.closeMenu();
    })

    document.onkeydown = (evt) => {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
        isEscape = evt.keyCode === 27;
      }
      if (isEscape) {
        this.closeMenu();
      }
    };
  }


  toggleBurger() {
    const menuItemsLevel0Mobile = document.querySelectorAll('.main-menu__item--level-1')
    menuItemsLevel0Mobile.forEach((itemMobile) => {

      const titles = document.querySelectorAll('.main-menu__link--level-0')
      titles.forEach((title) => {
        const span = document.querySelector('.main-menu__link--level-0 + .main-menu__download-item');
        if (!!span) {
          span.classList.add('dlc-menu-icon')
          title.appendChild(span)
        }
      })

      itemMobile.addEventListener('click', e => {
        if (e.target.classList.contains('main-menu__item--has-children')) {
          e.preventDefault();
          this.runMobileMenu(itemMobile)
        }

        if (itemMobile.classList.contains('main-menu__item--level-1') && !itemMobile.classList.contains('open')) {
          e.preventDefault();
          this.runMobileMenu(itemMobile)
        }
      })
    })

    if (document.body.classList.contains(this.burgerClass)) {
      document.body.classList.remove(this.burgerClass);
      Helper.removeClass(this.burger, 'burger-active');
      this.closeSearch()

      const openItems = document.querySelectorAll('.main-menu__item--has-children.open');
      openItems.forEach(item => {
        item.classList.remove('open');
      })

      const openMobiles = document.querySelectorAll('.open-mobile');
      openMobiles.forEach(openMobile => {
        openMobile.classList.remove('open-mobile');
      })

      const icons = document.querySelectorAll('.back-icon-menu')
      icons.forEach((item) => item.remove())

    } else {
      document.body.classList.add(this.burgerClass);
      Helper.addClass(this.burger, 'burger-active');
    }
  }

  runMobileMenu(menuItem) {
    this.closeSearch()
    this.headerBottomPart.style.display = 'none';
    if (menuItem.classList.contains('open')) {
      menuItem.classList.remove('open')
    } else {
      const activeSiblings = menuItem.parentElement.querySelectorAll('.open');
      activeSiblings.forEach(sibling => sibling.classList.remove('open'));
      menuItem.classList.add('open')
      const parent = menuItem.parentNode.parentNode.parentNode;
      parent.classList.add('open-mobile')
      this.addBackIcon(parent)
    }
  }

  addBackIcon(menuItem) {

    const backIcon = document.createElement('div')
    backIcon.classList.add('back-icon-menu')
    backIcon.innerHTML = `<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.08378 7.29289C1.69325 7.68342 1.69325 8.31658 2.08378 8.70711L8.44774 15.0711C8.83826 15.4616 9.47143 15.4616 9.86195 15.0711C10.2525 14.6805 10.2525 14.0474 9.86195 13.6569L4.2051 8L9.86195 2.34315C10.2525 1.95262 10.2525 1.31946 9.86195 0.928933C9.47143 0.538408 8.83826 0.538408 8.44774 0.928933L2.08378 7.29289ZM4.18652 7L2.79088 7L2.79088 9L4.18652 9L4.18652 7Z" fill="black"/>
    </svg>
    `

    const elementsToRemove = document.querySelectorAll('.main-menu__link--level-0')
    elementsToRemove.forEach((elementToRemove) => elementToRemove.style.display = 'none')
    backIcon.style.display = 'block';
    const wrapper = menuItem.closest('.main-menu--level-0');
    wrapper.insertBefore(backIcon, wrapper.children[0])
    backIcon.addEventListener('click', () => this.goBack(backIcon))
  }

  goBack(backIcon) {
    
    this.headerBottomPart.style.display = '';
    const allOpenItems = document.querySelectorAll('.open')
    allOpenItems.forEach((item) => item.classList.remove('open'))

    const allAnotherOpenItems = document.querySelectorAll('.open-mobile')
    allAnotherOpenItems.forEach((item) => item.classList.remove('open-mobile'))

    const elementsToRemove = document.querySelectorAll('.main-menu__link--level-0')
    elementsToRemove.forEach((elementToRemove) => elementToRemove.style.display = 'flex')

    backIcon.style.display = 'none';
  }

  openMenu(menuItem) {
    this.closeSearch()
    if (menuItem.classList.contains('open')) {
      menuItem.classList.remove('open')

      const activeMenuItems = menuItem.querySelectorAll('.open');
      activeMenuItems.forEach(child => child.classList.remove('open'));
    } else {
      const activeSiblings = menuItem.parentElement.querySelectorAll('.open');
      activeSiblings.forEach(sibling => sibling.classList.remove('open'));

      menuItem.classList.add('open')
      Helper.addClass(this.body, 'submenu-open');

      const title = menuItem.querySelector('.menu-title')
      if (!title) {
        this.addTitleToMenuWrapper(menuItem)
      }
    }
  }

  addTitleToMenuWrapper(menuItem) {
    const textToTitle = menuItem.querySelector('.main-menu__link--level-0 > span').innerText;
    const title = document.createElement('p');
    title.classList.add('menu-title');
    title.innerText = textToTitle;
    if (menuItem) {
      const span = menuItem.querySelector('.main-menu__link--level-0 + .main-menu__download-item');
      if (!!span) {
        span.classList.add('dlc-menu-icon')
        title.appendChild(span)
      }
    }

    const wrapper = menuItem.querySelector('.main-menu__inner--level-0')
    wrapper.insertBefore(title, wrapper.children[0])
  }

  closeMenu() {
    Helper.removeClass(this.body, 'submenu-open');
    if (this.menuItems) {
      document.body.classList.remove(this.burgerOpenClass);
      this.menuItems.forEach(item => item.classList.remove('open'));
    }
  }

  openSearch() {
    this.closeMenu()
    Helper.addClass(this.body, 'search-open');
    Helper.addClass(this.openItem, 'active');
    Helper.addClass(this.closeItem, 'active');
    Helper.addClass(this.searchContainer, 'active');
    Helper.slideDown(this.searchContainer);
    this.searchContainer.querySelector('input').focus();
    this.addBackIconToSearch()
  }


  addBackIconToSearch() {
    if (window.matchMedia('(max-width: 1170px)').matches) {
      const backIcon = document.createElement('div')
      backIcon.classList.add('back-icon-menu')
      backIcon.innerHTML = `<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.08378 7.29289C1.69325 7.68342 1.69325 8.31658 2.08378 8.70711L8.44774 15.0711C8.83826 15.4616 9.47143 15.4616 9.86195 15.0711C10.2525 14.6805 10.2525 14.0474 9.86195 13.6569L4.2051 8L9.86195 2.34315C10.2525 1.95262 10.2525 1.31946 9.86195 0.928933C9.47143 0.538408 8.83826 0.538408 8.44774 0.928933L2.08378 7.29289ZM4.18652 7L2.79088 7L2.79088 9L4.18652 9L4.18652 7Z" fill="black"/>
      </svg>
    `

      const searchField = document.querySelector('.site-header__searchfield')
      searchField.before(backIcon)
      backIcon.style.display = 'block';

      backIcon.addEventListener('click', () => {
        this.body.classList.remove('search-back')
        this.body.classList.remove('search-open')
        this.closeSearch()
        backIcon.style.display = 'none';
      })
    }
  }


  closeSearch() {
    Helper.removeClass(this.body, 'search-open');
    Helper.removeClass(this.openItem, 'active');
    Helper.removeClass(this.closeItem, 'active');
    Helper.removeClass(this.searchContainer, 'active');
    this.searchContainer.style.display = "none"
  }


  checkIfHeaderWithImage() {
    const nextElement = this.mainNav.nextElementSibling.firstElementChild;

    if (Helper.hasClass(nextElement, 'ns-hero')) {
      if (!Helper.hasClass(nextElement, 'no-image')) {
        Helper.addClass(this.mainNav, 'transparent-header');
        this.makeHeaderWhite(false);
      }
    }
  }

  makeHeaderWhite(bool) {
    if (bool) {
      Helper.addClass(this.mainNav, 'site-header--white');
    } else {
      if (Helper.hasClass(this.mainNav, 'transparent-header')) {
        Helper.removeClass(this.mainNav, 'site-header--white');
      }
    }
  }
}

export default Header;
